module.exports = __webpack_public_path__ + "img/proposal_background-sm.bea244f7.jpg";